import {commonControllers} from '@mintdata-wsp/common/controllers/CommonControllers';
import {FlowCloudController} from '@mintdata-wsp/common/controllers/flow/FlowCloudController';
import {SocketConfig} from '@mintdata-wsp/common/controllers/network/socket/SocketConfig';
import {ConfigUtil} from '@mintdata-wsp/common/util/ConfigUtil';
import {pubControllers} from '@mintdata-wsp/pub/controllers/PubControllers';

export class PubFlowCloudController extends FlowCloudController
{
    public init():void
    {
        super.init();

        if( commonControllers.context.isStandaloneMode() )
            return;

        const publishedApplicationId = pubControllers.integration.publishedApplicationId;

        const apiHostname = ConfigUtil.apiHostname();
        const apiSecure = ConfigUtil.apiSecure();
        const apiPort = apiSecure ? 443 : 80;

        const pubWsUrl = `/api/ws/publish?publishedApplicationId=${publishedApplicationId}`;

        const socketConfig = new SocketConfig(
            apiSecure,
            apiHostname,
            apiPort,
            pubWsUrl
        );

        this.setSocketConfig(socketConfig);
    }
}
